export const getCheckoutSessionQueryKey = (paywallId: number) => [
  "checkoutSession",
  paywallId,
];
